<template>
  <div class="main-agent-add">
    <div class="row">
      <div class="col-xl-12">
        <div class="m-portlet">
          <div class="m-portlet__body" v-loading="loading">
            <el-form
              :model="agentForm"
              label-width="150px"
              :rules="rules"
              ref="agentForm"
              class="cal-form"
            >
              <el-form-item prop="agentName" label="合作单位名称:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="合作单位名称"
                  v-model="agentForm.agentName"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <!--<el-form-item prop="agentCode" label="代理商编号:">-->
              <!--<el-input-->
              <!--:class="isEdit ? 'admin-k100' : 'admin-k100'"-->
              <!--placeholder="代理商编号"-->
              <!--v-model="agentForm.agentCode"-->
              <!--disabled-->
              <!--&gt;</el-input>-->
              <!--</el-form-item>-->
              <el-form-item prop="contactName" label="合作单位负责人:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="合作单位负责人"
                  v-model="agentForm.contactName"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="contactPhone" label="合作单位电话:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="合作单位电话"
                  v-model="agentForm.contactPhone"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="email" label="合作机构联系邮箱:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="合作机构联系邮箱"
                  v-model="agentForm.email"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="website" label="合作机构官网:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="合作机构官网"
                  v-model="agentForm.website"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="businessDirection" label="项目合作内容:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="项目合作内容"
                  v-model="agentForm.businessDirection"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="remarks" label="项目合作方式:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  placeholder="项目合作方式"
                  v-model="agentForm.remarks"
                  :disabled="!isEdit"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item prop="scope" label="项目合作范围:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  type="textarea"
                  placeholder="项目合作范围"
                  v-model="agentForm.scope"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item prop="about" label="简介:">
                <el-input
                  :class="isEdit ? 'admin-k100' : 'admin-k100'"
                  type="textarea"
                  placeholder="简介"
                  v-model="agentForm.about"
                  :disabled="!isEdit"
                ></el-input>
              </el-form-item>
              <el-form-item v-if="isEdit">
                <el-button @click="resetForm">重 置</el-button>
                <el-button
                  type="primary"
                  :loading="btnloading"
                  @click="onSaveAgent"
                  >确 定</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findAgentById, updateAgent } from "@/api/agentInfo";
import editor from "@/components/quillEditor/editor.vue";
import permission from "@/directive/permission"; // 权限判断指令
import FileUploader from "@/components/fileUploader";
import ImageUploader from "@/components/imageUploader";
import MyFile from "@/components/my-file";
export default {
  name: "editAgent",
  directives: { permission },
  components: {
    ImageUploader,
    FileUploader,
    MyFile
  },
  props: {
    isEdit: {
      type: Boolean,
      default: () => true
    },
    agentId: null
  },
  data() {
    return {
      agentForm: {
        agentId: null,
        agentName: null,
        agentCode: null,
        contactName: null,
        contactPhone: null,
        email: null,
        website: null,
        businessDirection: null,
        remarks: null,
        scope: null,
        projectSpecialty: null,
        about: null,
        uploadFile: null
      },
      rules: {
        agentName: [
          { required: true, message: "此项为必填", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      },
      contentValue: "",
      loading: false,
      btnloading: false,
      options: [],
      parentAgentList: [],
      showEdit: false
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query && !to.query.agentId) {
      next("/agent/addAgent");
    } else {
      next();
    }
  },
  watch: {
    agentId(val) {
      if (val) {
        this.getAgentInfo(val);
      }
    },
    isEdit(val) {
      this.getAgentInfo(this.agentId);
      this.showEdit = val;
    },
    showEdit(val) {
      if (!val) {
        this.contentValue = "";
      }
    }
  },
  activated() {
    if (this.$route.query && this.$route.query.agentId) {
      this.getAgentInfo(this.$route.query.agentId);
    }
  },
  mounted() {
    if (this.agentId) {
      this.getAgentInfo(this.agentId);
    }
  },
  methods: {
    jumpPage(router) {
      this.$router.push(router);
    },
    // 重置
    resetForm() {
      this.$refs["agentForm"].resetFields();
    },
    // 保存
    onSaveAgent() {
      this.$refs["agentForm"].validate(valid => {
        if (valid) {
          this.saveAgent();
        } else {
          return false;
        }
      });
    },
    uploadFile() {
      this.$refs["agentUploader"].submit();
    },
    saveAgent() {
      let that = this;
      that.btnloading = true;
      let data = this._.cloneDeep(this.agentForm);
      delete data.agentCode;
      updateAgent(data)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data > 0) {
              that.$message({
                message: "保存成功",
                type: "success"
              });
              that.resetForm();
              that.agentId = null;
              that.$emit("closed");
            } else {
              that.$message({
                message: "保存失败",
                type: "error"
              });
            }
          }
        })
        .finally(() => {
          this.btnloading = false;
        });
    },
    getAbout(val) {
      this.agentForm.about = val;
    },
    getAgentInfo(agentId) {
      let that = this;
      that.loading = true;
      findAgentById(agentId)
        .then(res => {
          if (res && res.code === "200") {
            that.agentForm = res.data;
            if (that.agentForm.uploadFile) {
              that.agentForm.uploadFile = JSON.parse(that.agentForm.uploadFile);
            }
            that.showEdit = true;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    cancel() {
      this.closeSelectedTag();
    },
    closeSelectedTag() {
      this.$store.dispatch("delView", this.$route).then(({ visitedViews }) => {
        const latestView = visitedViews.slice(-1)[0];
        if (latestView) {
          this.$router.push(latestView);
        } else {
          this.$router.push("/");
        }
      });
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  }
};
</script>

<style lang="scss" scoped>
.main-agent-add {
  .cal-form {
    .admin-k100 {
      width: 50%;
    }
    .admin-k100 {
      width: 100%;
    }
    i {
      &.el-icon-question--danger {
        font-size: 16px;
        color: #f4516c;
        margin-left: 10px;
      }
    }
  }
}
.quill-editor {
  height: 100% !important;
}
</style>
